const Fields = () => {
  const fields = [
    {
      label: "Title",
      type: "text",
      name: "title",
      required: true,
      message: 'You must provide title!',
      placeholder: "Title",
      size: "large",
      icon: "form"
    },
    {
      label: "Suject Line",
      type: "text",
      name: "subject",
      required: true,
      message: 'You must provide subject line!',
      placeholder: "Subject",
      size: "large",
      icon: "profile"
    },
    {
      label: "username",
      type: "text",
      name: "username",
      message: 'You must provide name!',
      placeholder: "Username",
      size: "large",
      icon: "user"
    },
    {
      label: "Name",
      type: "text",
      name: "name",
      required: true,
      message: 'You must provide a name!',
      placeholder: "Name",
      size: "large",
      icon: "user"
    },
    {
      label: "Email",
      type: "text",
      name: "email",
      required: true,
      message: 'You must provide an email!',
      placeholder: "Email",
      size: "large",
      icon: "mail"
    },
    {
      label: "Group",
      type: "text",
      name: "group",
      placeholder: "Group",
      size: "large",
      icon: "usergroup-add"
    },
    {
      label: "Group",
      type: "text",
      name: "groupUploader",
      placeholder: "Group",
      size: "large",
      icon: "usergroup-add"
    },
    {
      label: "Password",
      type: "password",
      name: "password",
      required: true,
      message: 'You must provide password!',
      placeholder: "Password",
      size: "large",
      icon: "eye-invisible",
    },
    {
      label: "Password Confirmation",
      type: "password",
      name: "passwordConfirmation",
      required: true,
      message: 'Passwords do not match!',
      placeholder: "Password Confirmation",
      size: "large",
      icon: "eye-invisible"
    },
    {
      label: "Company Name",
      type: "text",
      name: "companyName",
      placeholder: "Company",
      size: "large",
      icon: "shop"
    },
    {
      label: "City",
      type: "text",
      name: "city",
      placeholder: "Hollywood FL.",
      size: "large",
      icon: "environment"
    },
    {
      label: "Country",
      type: "text",
      name: "country",
      placeholder: "US",
      size: "large",
      icon: "shop"
    },
    {
      label: "Shopify URL",
      type: "text",
      name: "shopifyUrl",
      required: true,
      message: 'You must provide Shopify url!',
      placeholder: "example.myshopify.com",
      size: "large",
      icon: "global"
    },
    {
      label: "Api Key",
      type: "text",
      name: "apiKey",
      required: true,
      message: 'You must provide api key!',
      placeholder: "Api Key",
      size: "large",
      icon: "key"
    },
    {
      label: "Password",
      type: "password",
      name: "shopifyPassword",
      required: true,
      message: 'You must provide Stripe password!',
      placeholder: "Shopify Password",
      size: "large",
      icon: "eye-invisible"
    }
    
  ];
  return fields;
};

const FormFields = ["title", "subject"];
const UploadGroupFields = ["groupUploader"];
const RecipFields = ["name", "email", "group"];
const UserField = ["username"];
const AuthFields = ["email", "password"];
const RegisterFields = ["name", "email", "password", "passwordConfirmation"];
const AddFields = ["companyName", "city", "country"];
const ShopFields = ["apiKey", "shopifyPassword", "shopifyUrl", "group"];
const EmailFields = ["email"];

export const CampaignField = Fields().filter(key =>
  FormFields.includes(key.name)
);

export const RecipientFields = Fields().filter(key =>
  RecipFields.includes(key.name)
);

export const LoginFields = Fields().filter(key =>
  AuthFields.includes(key.name)
);

export const RegisterationFields = Fields().filter(key =>
  RegisterFields.includes(key.name)
);

export const UsernameFields = Fields().filter(key =>
  UserField.includes(key.name)
);

export const AddressFields = Fields().filter(key =>
  AddFields.includes(key.name)
);

export const ShopifyFields = Fields().filter(key =>
  ShopFields.includes(key.name)
);

export const SendTestEmailFields = Fields().filter(key =>
  EmailFields.includes(key.name)
);
export const UploadCSVGroupFields = Fields().filter(key =>
  UploadGroupFields.includes(key.name)
);
